import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, Validators} from '@angular/forms';
import {Store} from '@ngrx/store';
import {AdminPanelState} from '../../store/reducers/admin-panel.reducer';
import {CompanyModel} from '../../models/company.model';
import {TimeZoneService} from '@core/services/time-zone.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'lib-add-company',
  templateUrl: './add-company.component.html',
  styleUrls: ['./add-company.component.scss']
})
export class AddCompanyComponent implements OnInit, OnDestroy {

  addCompanyForm: any;
  addCompanyFormErrors: any;
  unsubscribe$ = new Subject<void>();
  sourceType = 'Company';
  result: any;

  constructor(public dialogRef: MatDialogRef<AddCompanyComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private formBuilder: FormBuilder,
              private timezoneService: TimeZoneService,
              private store: Store<AdminPanelState>) {
    this.addCompanyFormErrors = {
      companyName: {},
      description: {},
      source: {},
      domain: {},
      isActive: {},
    };
    this.result = {
      company: null,
      save: false
    };
  }

  ngOnInit() {
    this.addCompanyForm = this.formBuilder.group({
      companyName: ['', Validators.required],
      description: [''],
      source: ['Orbitax'],
      domain: [''],
      isActive: [false]
    });

    this.addCompanyForm.controls['source'].disable();

    this.addCompanyForm.valueChanges.subscribe(() => {
      this.onFormValueChanged();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onFormValueChanged() {
    for (const field in this.addCompanyFormErrors) {
      if (!this.addCompanyFormErrors.hasOwnProperty(field)) {
        continue;
      }

      this.addCompanyFormErrors[field] = {};
      const control = this.addCompanyForm.get(field);

      if (control && control.dirty && !control.valid) {
        this.addCompanyFormErrors[field] = control.errors;
      }
    }
  }

  onSave() {
    if (this.addCompanyForm.valid) {
      this.addCompanyForm.controls['companyName'].setValue(this.addCompanyForm.controls['companyName'].value.trim());
      this.addCompanyForm.controls['description'].setValue(this.addCompanyForm.controls['description'].value.trim());
      this.addCompanyForm.controls['domain'].setValue(this.addCompanyForm.controls['domain'].value.trim());

      // TODO: show warning on adding domain from excluded list
      const company = new CompanyModel({
        companyId: '',
        companyName: this.addCompanyForm.value.companyName,
        description: this.addCompanyForm.value.description,
        registrationDate: this.timezoneService.getUTCDateWithoutTime(new Date()),
        registeredBy: this.data.userName,
        source: this.addCompanyForm.controls['source'].value,
        isActive: this.addCompanyForm.value.isActive,
        domain: this.addCompanyForm.value.domain
      });

      this.result.save = true;
      this.result.company = company;
    }
  }
}
